import { compiledBlock as _compiledBlock } from "million/react";
import { block as _block } from "million/react";
import { useState, useRef, useEffect, useMemo, useCallback } from "react";
import InputCard from "../components/InputCard";
import ConnectedAccountsContainer from "../components/ConnectedAccountsContainer";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { ref, uploadBytesResumable, deleteObject, listAll } from "firebase/storage";
import { db, storage } from "../firebase";
import AddNewAccountModal from "../components/AddNewAccountModal";
import { useUserData } from "../UserDataContext";
import Rive from "rive-react";
import PlacesInputCard from "../components/PlacesInputCard";
import { useIdentifyUser } from "../hooks/useIdentifyUser";
import React, { forwardRef } from "react";
import { motion, useMotionValue, useTransform, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import Intercom from "@intercom/messenger-js-sdk";
const Settings_1 = _compiledBlock(_props => <div className="h-screen w-screen flex items-center justify-center">
        {_props.v0}
      </div>, {
  name: "Settings_1",
  portals: ["v0"]
});
const JSX_content_1 = _compiledBlock(_props2 => <div className="self-stretch flex flex flex-col items-start justify-start text-sm">
        <div className="self-stretch flex-1 rounded-lg flex flex-col items-start justify-start gap-[48px]">
          <div className="self-stretch flex flex-row items-start justify-start gap-[64px]">
            {_props2.v0}
            {_props2.v1}
            {_props2.v2}
          </div>

          <div className="self-stretch flex flex-row items-start justify-start gap-[64px]">
            {_props2.v3}
            {_props2.v4}
            <div className="flex-1 flex flex-col items-start justify-start gap-[8px]">
              <div className="self-stretch relative tracking-[-0.1px] leading-[20px] font-medium">
                {_props2.v5}{" "}
                {_props2.v6}
              </div>
              <div className="self-stretch rounded-md shadow-[0px_1px_2px_rgba(16,_24,_40,_0.04)] overflow-hidden flex flex-row items-start justify-end">
                {_props2.v7}
                <div className="self-stretch rounded-md shadow-[0px_1px_2px_rgba(16,_24,_40,_0.04)] overflow-hidden flex flex-row items-start justify-between flex-1">
                  <input className="font-text-l-regular text-mini bg-base-white focus:outline-none focus:ring focus:ring-green-50 focus:border-mediumseagreen-200 flex-1 rounded-tl-md rounded-tr-none rounded-br-none rounded-bl-md box-border h-[46px] overflow-hidden flex flex-row py-[11px] px-4 items-center justify-start border-[1px] border-solid border-neutral-700 select-none" placeholder="No file chosen" value={_props2.v8} readOnly />
                  <button className="cursor-pointer [border:none] py-3 px-[18px] bg-neutral-100 rounded-tl-none rounded-tr-md rounded-br-md rounded-bl-none overflow-hidden flex flex-row items-center justify-between gap-[6px] border-t-[1px] border-solid border-neutral-700 border-r-[1px] border-b-[1px]" onClick={_props2.v9}>
                    <img className="relative w-5 h-5 shrink-0 overflow-hidden hidden" alt="" src="/placeholder2.svg" />
                    <div className="relative text-mini leading-[22px] font-semibold font-text-l-regular text-gray-700 text-left">
                      Upload
                    </div>
                    <img className="relative w-5 h-5 shrink-0 overflow-hidden hidden" alt="" src="/placeholder3.svg" />
                  </button>
                </div>
              </div>
              <div className="self-stretch relative tracking-[-0.1px] leading-[20px] text-gray-50 hidden">
                Hint text
              </div>
            </div>
          </div>
          <div className="self-stretch h-[394px] shrink-0 flex flex-row items-start justify-start gap-[64px]">
            <div className="self-stretch flex-1 flex flex-col items-start justify-start gap-[8px] pb-4">
              <div className="self-stretch relative tracking-[-0.1px] leading-[20px] font-medium">
                Key information (unique skills, awards, or anything else you
                want mentioned in your applications)
              </div>
              <textarea maxLength="2000" className="bg-base-white focus:outline-none focus:ring focus:ring-green-50 focus:border-mediumseagreen-200 font-text-l-regular text-mini self-stretch flex-1 rounded-md shadow-[0px_1px_2px_rgba(16,_24,_40,_0.04)] flex flex-row py-3 px-4 items-start justify-start border-[1px] border-solid border-neutral-700 resize-none" placeholder={`Feel free to mention anything you think might be applicable. The more information you enter helps the AI specialize your applications and have a higher success rate, so say as much as you want!`} value={_props2.v10} onChange={_props2.v11} />
              <div className="self-stretch relative tracking-[-0.1px] leading-[20px] text-gray-50 hidden">
                Hint text
              </div>
              <div className="[border:none] py-4 self-stretch bg-transparent rounded-t-none rounded-b-3xs flex flex-row items-center justify-start gap-[12px]">
                <div className="rounded-8xs overflow-hidden flex flex-row items-center justify-center gap-[6px]">
                  <img className="relative w-[18px] h-[18px] shrink-0 hidden" alt="" src="/add-icon.svg" />
                  <div className="relative text-sm leading-[20px] font-semibold font-text-l-regular text-primary-600 text-left">
                    Autosaving On
                  </div>
                </div>
              </div>
            </div>
            <div className="self-stretch rounded-3xs w-[352px] h-[378px] shrink-0 overflow-hidden flex flex-col items-center justify-start gap-[8px]">
              <div className="self-stretch relative text-sm tracking-[-0.1px] leading-[20px] font-medium font-text-l-regular text-gray-700 text-left">
                External Accounts (Github, LinkedIn, etc.)
              </div>
              <div className="overflow-y-auto shadow-[0px_1px_2px_rgba(16,_24,_40,_0.04)] self-stretch flex-1 rounded-3xs bg-base-white flex flex-col items-center justify-start border-[1px] border-solid border-neutral-700">
                <div className="self-stretch flex-1 flex flex-col py-0 px-4 items-start justify-start width-full">
                  {_props2.v12}
                </div>
              </div>
              <button onClick={_props2.v13} className="cursor-pointer [border:none] py-4 px-5 self-stretch bg-transparent rounded-t-none rounded-b-3xs flex flex-row items-center justify-start gap-[12px]">
                <div className="rounded-8xs overflow-hidden flex flex-row items-center justify-center gap-[6px]">
                  <img className="relative w-[18px] h-[18px] shrink-0 hidden" alt="" src="/add-icon.svg" />
                  <div className="relative text-sm leading-[20px] font-semibold font-text-l-regular text-primary-600 text-left">
                    Add New
                  </div>
                  <img className="relative w-[18px] h-[18px] shrink-0 overflow-hidden" alt="" src="/plus.svg" />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>, {
  name: "JSX_content_1",
  portals: ["v0", "v1", "v2", "v3", "v4", "v5", "v6", "v7", "v12"]
});
const JSX_content_2 = _compiledBlock(_props3 => <slot>
        <div className="bg-white border-neutral-700 border-[1px] border-solid rounded-lg overflow-hidden flex flex-col self-stretch text-light-100">
          <div className="pt-6">
            <div className="text-base font-semibold text-gray-600 px-8 pb-6">
              Notification Settings
            </div>

            {/* Job Recommendation Emails Section */}
            <div onClick={_props3.v0} className="space-y-4 hover:bg-neutral-50 duration-150 transition-all border-neutral-700 border-t-[1px] border-solid py-4 px-8">
              <div className="font-semibold text-sm text-light-100 cursor-pointer">
                Job Recommendation Emails
                {_props3.v1}
              </div>
              {_props3.v2}
            </div>

            {/* Application Confirmation Emails Section */}
            <div onClick={_props3.v3} className="space-y-4 hover:bg-neutral-50 duration-150 transition-all border-neutral-700 border-t-[1px] border-solid py-4 px-8">
              <div className="font-semibold text-sm text-light-100 cursor-pointer">
                Application Confirmation Emails
                {_props3.v4}
              </div>
              {_props3.v5}
            </div>

            {/* Marketing Emails Section */}
            <div onClick={_props3.v6} className="space-y-4 hover:bg-neutral-50 duration-150 transition-all border-neutral-700 border-t-[1px] border-solid py-4 px-8">
              <div className="font-semibold text-sm text-light-100 cursor-pointer">
                Marketing Emails
                {_props3.v7}
              </div>
              {_props3.v8}
            </div>
          </div>
        </div>
        <div className="bg-white border-neutral-700 border-[1px] border-solid rounded-lg overflow-hidden flex flex-col self-stretch text-light-100 mt-6">
          <div className="pt-6">
            <div className="text-base font-semibold text-gray-600 px-8 pb-6">
              Employer Outreach
            </div>

            {/* Job Recommendation Emails Section */}
            <div onClick={_props3.v9} className="space-y-4 hover:bg-neutral-50 duration-150 transition-all border-neutral-700 border-t-[1px] border-solid py-4 px-8">
              <div className="font-semibold text-sm text-light-100 cursor-pointer">
                Contact Info Sharing{" "}
                {_props3.v10}
              </div>
              {_props3.v11}
            </div>
          </div>
        </div>
      </slot>, {
  name: "JSX_content_2",
  portals: ["v1", "v2", "v4", "v5", "v7", "v8", "v10", "v11"]
});
const JSX_content_3 = _compiledBlock(_props4 => <slot>
        <div className="bg-white border-neutral-700 border-[1px] border-solid rounded-lg overflow-hidden flex flex-col self-stretch">
          <div className="space-y-6 py-6">
            <div className="flex justify-between items-start px-8">
              <div className="text-base font-semibold max-w-[50%]">
                Referral Program
              </div>
            </div>

            <div className="">
              <div className="flex flex-col items-start border-neutral-700 border-solid border-t-[1px] py-4 px-8">
                <div className="text-sm font-semibold text-light-100">
                  Your Referral Link
                  {_props4.v0}
                </div>

                <div className="text-xs font-regular text-light-100 mt-2">
                  Share this link with your friends to earn rewards.
                </div>
                <div className="flex items-center pt-3 pb-2">
                  <div className="flex items-start justify-start text-left text-sm text-gray-700 font-text-l-regular w-full">
                    <div className="flex w-full">
                      <input className="font-text-l-regular text-mini focus:outline-none focus:ring focus:ring-green-50/10 transform-gpu transition-all duration-300 hover:border-neutral-300 focus:border-mediumseagreen-200 bg-base-white rounded-l-beast shadow-[0px_1px_2px_rgba(16,_24,_40,_0.04)] box-border flex flex-row py-3 px-4 items-center justify-start border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutral-700" type={"text"} value={_props4.v1} readOnly style={_props4.v2} />
                      <button onClick={_props4.v3} className={_props4.v4}>
                        {_props4.v5}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-neutral-700 border-solid border-t-[1px] pt-6 px-8">
                <div className="text-sm font-semibold text-light-100 mb-2">
                  Referral Rewards
                </div>
                <div className="space-y-2">
                  {_props4.v6}
                </div>
              </div>
              <div className="pt-4 px-8">
                <div className="text-sm font-semibold text-light-100 mb-2">
                  Reward Progress
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div className="bg-mediumseagreen-200 h-2.5 rounded-full" style={_props4.v7}></div>
                </div>
                <div className="text-xs text-gray-500 mt-2">
                  {_props4.v8} / {_props4.v9} referrals for the next
                  reward
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white border-neutral-700 border-[1px] border-solid rounded-lg overflow-hidden flex flex-col self-stretch text-light-100 mt-6">
          <div className="pt-6">
            <div className="text-base font-semibold text-gray-600 px-8 pb-6">
              Your Referrals
            </div>

            <div onClick={_props4.v10} className="space-y-4 hover:bg-neutral-50 duration-150 transition-all border-neutral-700 border-t-[1px] border-solid py-4 px-8">
              <div className="font-semibold text-sm text-light-100 cursor-pointer">
                Tracking Coming Soon
                {_props4.v11}
              </div>
              {_props4.v12}
            </div>
          </div>
        </div>
      </slot>, {
  name: "JSX_content_3",
  portals: ["v0", "v5", "v6", "v8", "v9", "v11", "v12"]
});
const JSX_content_4 = _compiledBlock(_props5 => <div className="bg-white border-neutral-700 border-[1px] border-solid rounded-lg overflow-hidden flex flex-col self-stretch">
        <div className="space-y-6 px-8 py-6">
          <div className="text-4xl font-semibold mb-4">Creator Rewards</div>

          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <div>
                <div className="text-lg font-medium text-gray-700">
                  Your Points
                </div>
                <div className="text-sm text-gray-500">
                  Track your progress and redeem rewards.
                </div>
              </div>
              <div className="text-2xl font-bold text-gray-700">
                {_props5.v0} Points
              </div>
            </div>

            <div className="border-neutral-700 border-[1px] border-solid rounded-lg p-4 bg-neutral-50">
              <div className="font-semibold text-gray-700 mb-2">
                Available Rewards
              </div>
              <div className="text-sm text-gray-600">
                <ul className="list-disc pl-6">
                  <li>100 Points: $10 Amazon Gift Card</li>
                  <li>500 Points: $50 Amazon Gift Card</li>
                  <li>1000 Points: $100 Amazon Gift Card</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>, {
  name: "JSX_content_4",
  portals: ["v0"]
});
const Settings_2 = _compiledBlock(_props6 => <div className="relative bg-white w-full h-screen flex flex-row items-start justify-start text-left text-9xl text-gray-700 font-text-l-regular">
      <div className="self-stretch flex-1 flex flex-col pt-8 items-start justify-start">
        <div className="w-full flex flex-col items-start justify-start">
          <div className="px-8 self-stretch flex flex-row items-center justify-start mb-6">
            <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-4xl font-bold text-white mr-4">
              {_props6.v0}
            </div>
            <div>
              <div className="relative tracking-[-0.01em] leading-[38px] font-semibold mb-1 mt-2">
                {_props6.v1}
              </div>
              <div className="relative text-base tracking-[-0.1px] leading-[24px] text-gray-500">
                {_props6.v2}
              </div>
            </div>
          </div>
          <div className="self-stretch items-center flex border-solid border-b-[1px] border-neutral-700 pt-2.5 px-8">
            <div className="relative flex flex-row pb-2.5 w-full items-center h-full justify-between">
              <div className="relative flex flex-row gap-[8px] items-center h-full">
                {_props6.v3}
              </div>
              <div className="relative flex flex-row items-center h-full">
                {_props6.v4}
              </div>
              <div className="absolute bottom-[4px] z-5 h-[2px] bg-mediumseagreen-200 transition-all duration-300" style={_props6.v5} />
            </div>
          </div>
        </div>
        <div className="py-8 px-8 self-stretch flex-grow bg-neutral-50 overflow-y-auto">
          {_props6.v6}
        </div>
      </div>
      {_props6.v7}
    </div>, {
  name: "Settings_2",
  portals: ["v0", "v1", "v2", "v3", "v4", "v6", "v7"]
});
const Settings = () => {
  const textVariants = {
    collapsed: {
      opacity: 0,
      x: -5
    },
    expanded: {
      opacity: 1,
      x: 0
    },
    exit: {
      opacity: 0,
      x: -5
    }
  };
  const badgeStyle = {
    backgroundColor: "#E6FBF0",
    color: "#5BC68D",
    fontSize: "0.7em",
    padding: "2px 4px",
    borderRadius: "4px",
    marginLeft: "10px",
    border: "1px solid #5BC68D"
  };
  useIdentifyUser();
  const prod = true;
  const {
    user,
    userData,
    setUserData,
    isAuthenticated,
    isLoading
  } = useUserData();
  const [currPage, setCurrPage] = useState(0);
  const [filename, setFilename] = useState("");
  const fileInputRef = useRef(null);
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const docRef = doc(db, "Profiles", isAuthenticated && user.uid);
  const handleSelect = fulladdress => {
    updateDoc(docRef, {
      address: fulladdress
    }, {
      merge: true
    });
    setUserData({
      ...userData,
      address: fulladdress
    });
  };
  useEffect(() => {
    if (userData.filename) {
      setFilename(userData.filename);
    }
  }, [userData.filename]);
  const handleSignOut = async () => {
    try {
      await auth.signOut();
      navigate("/login");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };
  {
    /*Intercom({
    app_id: "qgss7lxp",
    user_id: user.uid, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
    name: userData.name, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
    email: userData.email, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
    created_at: "1704067200", // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
    });*/
  }
  const testFileSize = async file => {
    if (file.size / 1000000 > 5) {
      alert("file too big");
    } else {
      const allowedExtensions = /(\.txt|\.pdf|\.docx)$/i;
      if (!allowedExtensions.exec(file.name)) {
        alert("Invalid file type");
      } else {
        const dbRef = ref(storage, String(user.uid));
        const res = await listAll(dbRef);
        try {
          for (let item of res.items) {
            if (item.name === file.name) {
              await deleteObject(item);
            }
          }
        } catch (error) {
          return;
        }
        const dbRef2 = ref(storage, String(user.uid) + "/resumes/");
        const res2 = await listAll(dbRef2);
        try {
          for (let item of res2.items) {
            if (item.name === file.name) {
              await deleteObject(item);
            }
          }
        } catch (error) {
          return;
          // Handle the error as needed
        }
        const storageRef = ref(storage, String(user.uid) + "/" + file.name);
        const uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on("state_changed", snapshot => {
          setFilename("Uploading... " + String(Math.floor(snapshot.bytesTransferred / snapshot.totalBytes * 100)) + "%");
        }, error => {
          console.error("Upload failed", error);
        }, () => {
          setFilename(file.name);
          updateDoc(docRef, {
            filename: file.name,
            allResumes: arrayUnion(file.name)
          }, {
            merge: true
          });
          const updatedResumes = userData.allResumes ? [...new Set([...userData.allResumes, file.name])] : [file.name];
          setUserData({
            ...userData,
            filename: file.name,
            allResumes: updatedResumes
          });
        });
        // const storageRef2 = ref(storage, user.uid + "/resumes/" + file.name);
        // const uploadTask2 = uploadBytesResumable(storageRef2, file);
        // uploadTask2.on(
        //   "state_changed",
        //   (snapshot) => {
        //   },
        //   (error) => {
        //     //console.error("Upload failed", error);
        //   },
        // );
      }
    }
  };
  const handleChooseFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      const fileInput = document.createElement("input");
      fileInput.setAttribute("type", "file");
      fileInput.setAttribute("id", "fileInput");
      fileInput.setAttribute("style", "display: none");
      fileInput.addEventListener("change", e => {
        const file = e.target.files[0];
        const fileNameInput = document.querySelector("#fileNameInput");
        fileNameInput.value = file.name;
      });
      document.body.appendChild(fileInput);
      fileInput.click();
    }
  };
  const accounts = {
    linkedin: ["LinkedIn", "/linkedin.svg"],
    figma: ["Figma", "/figma.svg"],
    github: ["Github", "/github.svg"],
    dribbble: ["Dribbble", "/dribbble.svg"],
    stackoverflow: ["StackOverflow", "/stack.svg"],
    twitter: ["twitter", "/twitter.svg"]
  };
  const Loader = () => <Rive src="/loadingwrangle.riv" className="w-screen h-screen"></Rive>;
  if (isLoading) {
    return /*@million jsx-skip*/<Settings_1 v0={<Loader />} />;
  }
  const referralLink = `https://app.wranglejobs.com/login?referral=${user.uid}`;
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const referralStages = [{
    count: 5,
    reward: "LinkedIn profile review"
  }, {
    count: 10,
    reward: "One-on-one resume building"
  }, {
    count: 20,
    reward: "Practice interview session"
  }];
  const Checkbox = ({
    checked,
    onToggle,
    label
  }) => {
    const pathLength = useMotionValue(checked ? 1 : 0);
    const opacity = useTransform(pathLength, [0, 0.5], [0, 1]);
    useEffect(() => {
      pathLength.set(checked ? 1 : 0);
    }, [checked, pathLength]);
    const handleClick = event => {
      event.stopPropagation();
      onToggle();
    };
    return <div className="relative flex items-center" onClick={handleClick}>
        <motion.div className={`relative h-5 w-5 cursor-pointer rounded-md border-[1px] border-solid transition-all duration-500 ${checked ? "border-mediumseagreen-200 bg-mediumseagreen-200" : "border-gray-neutral-200 bg-fafbfc"}`} initial={false} animate={{
        backgroundColor: checked ? "#5cd193" : "#fafbfc"
      }}>
          <motion.svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3.5" stroke="white" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-3.5 w-3.5" initial={false} animate={{
          pathLength: checked ? 1 : 0,
          opacity
        }} transition={{
          duration: 0.4
        }}>
            <motion.path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" style={{
            pathLength,
            opacity
          }} />
          </motion.svg>
        </motion.div>
        <span className="ml-2 text-sm text-light-100">{label}</span>
      </div>;
  };
  const titles = ["Application information", "Notification settings", "Referral program", "Sign out"];
  const [isJobRecommendationOpen, setIsJobRecommendationOpen] = useState(false);
  const [isApplicationConfirmationOpen, setIsApplicationConfirmationOpen] = useState(false);
  const [isMarketingEmailsOpen, setIsMarketingEmailsOpen] = useState(false);
  const [isEmployerOpen, setIsEmployerOpen] = useState(false);
  const handleToggle = (field, value) => {
    updateDoc(docRef, {
      [field]: value
    }, {
      merge: true
    });
    setUserData(prevData => ({
      ...prevData,
      [field]: value
    }));
  };
  const currentReferrals = userData.referrals?.length ?? 0;
  const nextStage = referralStages.find(stage => currentReferrals < stage.count) || referralStages[referralStages.length - 1];
  const content = {
    0: /*@million jsx-skip*/<JSX_content_1 v0={<InputCard regex={new RegExp("^[a-zA-Z]+[-' ]+[a-zA-Z]+$")} maxlen="30" required={true} titleText="Full Name" inputText="Name" value={userData.name || ""} onChange={value => {
      updateDoc(docRef, {
        name: value
      }, {
        merge: true
      });
      setUserData({
        ...userData,
        name: value
      });
    }} />} v1={<InputCard regex={new RegExp("(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])")} maxlen="40" titleText="Email" inputText="Email" value={userData.email || ""} required={true} onChange={value => {
      updateDoc(docRef, {
        email: value
      }, {
        merge: true
      });
      setUserData({
        ...userData,
        email: value
      });
    }} />} v2={<InputCard regex={new RegExp("^(?=([+()\\d\\s-]*\\d){10,})[+\\d()\\s-]*$")} maxlen="17" titleText="Phone" inputText="Number" value={userData.phone || ""} required={true} onChange={value => {
      updateDoc(docRef, {
        phone: value
      }, {
        merge: true
      });
      setUserData({
        ...userData,
        phone: value
      });
    }} />} v3={<PlacesInputCard maxlen="50" titleText="Address" inputText="City, State, Postal Code" value={userData.address || ""} required={true} onSelect={handleSelect} onChange={value => {
      updateDoc(docRef, {
        address: value
      }, {
        merge: true
      });
      setUserData({
        ...userData,
        address: value
      });
    }} />} v4={<InputCard regex={new RegExp(".*")} maxlen="40" titleText="Portfolio" inputText="Personal site, Github, etc." value={userData.portfolio || ""} onChange={value => {
      updateDoc(docRef, {
        portfolio: value
      }, {
        merge: true
      });
      setUserData({
        ...userData,
        portfolio: value
      });
    }} />} v5={<AnimatePresence mode="wait">
                  <motion.span>{`Resume `}</motion.span>
                </AnimatePresence>} v6={<AnimatePresence mode="wait">
                  <motion.span initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -10
      }} transition={{
        duration: 0.2
      }} style={{
        color: "red"
      }}>
                    *
                  </motion.span>
                </AnimatePresence>} v7={<input type="file" id="fileInput" ref={fileInputRef} style={{
      display: "none"
    }} onChange={e => {
      const file = e.target.files[0];
      testFileSize(file);
    }} />} v8={filename || ""} v9={handleChooseFile} v10={userData.keyInfo} v11={e => {
      const val = e.target.value;
      updateDoc(docRef, {
        keyInfo: val
      }, {
        merge: true
      });
      setUserData({
        ...userData,
        keyInfo: val
      });
    }} v12={Object.keys(accounts).map(key => {
      if (userData[key]) {
        return <ConnectedAccountsContainer key={key} socialMediaHandle={accounts[key][0]} acctHandle={userData[key]} propBackgroundImage={`url("${accounts[key][1]}")`} visible={true} setInvisible={() => {
          setUserData({
            ...userData,
            [key]: null
          });
        }} />;
      }
      return null;
    })} v13={() => setShowAddNewModal(true)} />,
    1: /*@million jsx-skip*/<JSX_content_2 v0={() => setIsJobRecommendationOpen(!isJobRecommendationOpen)} v1={<AnimatePresence mode="wait">
                  {(userData.jobEmails || userData.jobEmails) && <motion.span initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -10
      }} transition={{
        duration: 0.2
      }} style={badgeStyle}>
                      {"Enabled"}
                    </motion.span>}
                </AnimatePresence>} v2={<AnimatePresence>
                {isJobRecommendationOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="space-y-2">
                    <div className="text-xs text-light-100 mt-2">
                      Select how often you want to receive job recommendations.
                    </div>
                    <div className="flex space-x-4">
                      <Checkbox checked={userData.jobEmails !== undefined ? userData.jobEmails : true} onToggle={() => handleToggle("jobEmails", !userData.jobEmails)} label="Email" />
                      <Checkbox checked={userData.jobSMS || false} onToggle={() => handleToggle("jobSMS", !userData.jobSMS)} label="SMS" />
                    </div>
                  </motion.div>}
              </AnimatePresence>} v3={() => setIsApplicationConfirmationOpen(!isApplicationConfirmationOpen)} v4={<AnimatePresence mode="wait">
                  {(userData.applicationConfirmationEmails || userData.applicationConfirmationSMS) && <motion.span initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -10
      }} transition={{
        duration: 0.2
      }} style={badgeStyle}>
                      {"Enabled"}
                    </motion.span>}
                </AnimatePresence>} v5={<AnimatePresence>
                {isApplicationConfirmationOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="space-y-2">
                    <div className="text-xs text-light-100 mt-2">
                      Get notified when your job applications are submitted.
                    </div>
                    <div className="flex space-x-4">
                      <Checkbox checked={userData.applicationConfirmationEmails !== undefined ? userData.applicationConfirmationEmails : true} onToggle={() => handleToggle("applicationConfirmationEmails", !userData.applicationConfirmationEmails)} label="Email" />
                      <Checkbox checked={userData.applicationConfirmationSMS || false} onToggle={() => handleToggle("applicationConfirmationSMS", !userData.applicationConfirmationSMS)} label="SMS" />
                    </div>
                  </motion.div>}
              </AnimatePresence>} v6={() => setIsMarketingEmailsOpen(!isMarketingEmailsOpen)} v7={<AnimatePresence mode="wait">
                  {(userData.marketingEmails || userData.marketingSMS) && <motion.span initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -10
      }} transition={{
        duration: 0.2
      }} style={badgeStyle}>
                      {"Enabled"}
                    </motion.span>}
                </AnimatePresence>} v8={<AnimatePresence>
                {isMarketingEmailsOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="space-y-2">
                    <div className="text-xs text-light-100 mt-2">
                      Receive updates and promotions from us.
                    </div>
                    <div className="flex space-x-4">
                      <Checkbox checked={userData.marketingEmails !== undefined ? userData.marketingEmails : true} onToggle={() => handleToggle("marketingEmails", !userData.marketingEmails)} label="Email" />
                      <Checkbox checked={userData.marketingSMS || false} onToggle={() => handleToggle("marketingSMS", !userData.marketingSMS)} label="SMS" />
                    </div>
                  </motion.div>}
              </AnimatePresence>} v9={() => setIsEmployerOpen(!isEmployerOpen)} v10={<AnimatePresence mode="wait">
                  {(userData.employerEmails || userData.employerSMS) && <motion.span initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -10
      }} transition={{
        duration: 0.2
      }} style={badgeStyle}>
                      {"Enabled"}
                    </motion.span>}
                </AnimatePresence>} v11={<AnimatePresence>
                {isEmployerOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="space-y-2">
                    <div className="text-xs text-light-100 mt-2">
                      Get contacted directly by employers or recruiters.
                    </div>
                    <div className="flex space-x-4">
                      <Checkbox checked={userData.employerEmails !== undefined ? userData.employerEmails : true} onToggle={() => handleToggle("employerEmails", !userData.employerEmails)} label="Email" />
                      <Checkbox checked={userData.employerSMS || false} onToggle={() => handleToggle("employerSMS", !userData.employerSMS)} label="SMS" />
                    </div>
                  </motion.div>}
              </AnimatePresence>} />,
    2: /*@million jsx-skip*/<JSX_content_3 v0={<motion.span initial={{
      opacity: 0,
      x: -10
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -10
    }} transition={{
      duration: 0.2
    }} style={badgeStyle}>
                    {"Active"}
                  </motion.span>} v1={referralLink} v2={{
      width: `calc(${referralLink.length}ch - 3rem)`
    }} v3={handleCopy} v4={`px-4 py-3 rounded-r-beast transition-all duration-300 ${copied ? "bg-mediumseagreen-200 border-solid border-[1px] border-mediumseagreen-200 text-white" : "bg-neutral-100 border-solid border-[1px] border-neutral-700 hover:bg-neutral-50 text-black"}`} v5={copied ? "Copied!" : "Copy"} v6={referralStages.map((stage, index) => <div key={index} className="text-sm text-light-200 flex items-center">
                      <div className="flex items-start text-sm font-medium text-light-200 mb-2">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
                          <path opacity="0.4" d="M10.5656 1.80358C10.9816 1.48611 11.4388 1.25 12 1.25C12.5612 1.25 13.0184 1.48611 13.4344 1.80358C13.8241 2.10089 14.2539 2.53075 14.7568 3.03368L14.7922 3.06904C15.3067 3.58361 15.7553 3.78626 16.4479 3.78626C16.5345 3.78626 16.6442 3.78315 16.7682 3.77964C17.083 3.77072 17.49 3.75919 17.8456 3.78921C18.3672 3.83325 19.0205 3.97339 19.5187 4.46747C20.0207 4.96533 20.1643 5.62129 20.2097 6.14615C20.2407 6.50496 20.2292 6.91507 20.2203 7.2321C20.2168 7.35567 20.2137 7.46534 20.2137 7.55206C20.2137 8.00288 20.2638 8.25468 20.3507 8.45354C20.4399 8.65779 20.5973 8.87416 20.931 9.20784L20.9664 9.24322C21.4693 9.74607 21.8991 10.1759 22.1964 10.5655C22.5139 10.9816 22.75 11.4388 22.75 12C22.75 12.5611 22.5139 13.0183 22.1964 13.4344C21.8991 13.8242 21.4691 14.2541 20.9661 14.7571L20.9309 14.7922C20.5973 15.1258 20.4399 15.3422 20.3507 15.5464C20.2638 15.7453 20.2137 15.9971 20.2137 16.4479C20.2137 16.5346 20.2168 16.644 20.2203 16.7676C20.2292 17.0846 20.2407 17.495 20.2097 17.8539C20.1643 18.3787 20.0207 19.0347 19.5186 19.5326C19.0204 20.0266 18.3671 20.1667 17.8456 20.2107C17.49 20.2408 17.083 20.2292 16.7682 20.2203C16.6442 20.2168 16.5345 20.2137 16.4479 20.2137C16.0067 20.2137 15.7587 20.2581 15.5635 20.3386C15.3685 20.4191 15.1599 20.5632 14.8458 20.8773C14.7787 20.9445 14.6902 21.0392 14.5882 21.1486C14.3583 21.3951 14.0593 21.7155 13.7801 21.9596C13.3563 22.33 12.7485 22.75 12 22.75C11.2516 22.75 10.6437 22.33 10.22 21.9596C9.94071 21.7155 9.64176 21.3951 9.4118 21.1486C9.3098 21.0392 9.22134 20.9445 9.15424 20.8774C8.84006 20.5632 8.63147 20.4191 8.43645 20.3386C8.24126 20.2581 7.99328 20.2137 7.55206 20.2137C7.4655 20.2137 7.35581 20.2168 7.23179 20.2203C6.91703 20.2292 6.50997 20.2408 6.15443 20.2107C5.63287 20.1667 4.97961 20.0266 4.48139 19.5326C3.97933 19.0347 3.83569 18.3787 3.79029 17.8539C3.75926 17.495 3.7708 17.0849 3.77972 16.7679C3.7832 16.6442 3.78628 16.5347 3.78628 16.4479C3.78628 15.9971 3.73619 15.7453 3.64932 15.5464C3.56011 15.3422 3.40272 15.1258 3.06906 14.7922L3.03395 14.7571C2.53091 14.2541 2.10095 13.8242 1.80358 13.4344C1.48613 13.0183 1.25001 12.5611 1.25 12C1.25001 11.4388 1.48612 10.9816 1.80358 10.5655C2.10089 10.1759 2.53075 9.74606 3.03367 9.24319L3.06902 9.20784C3.58371 8.69315 3.78628 8.24448 3.78628 7.55206C3.78628 7.46549 3.78317 7.35581 3.77966 7.23181C3.77075 6.91704 3.75922 6.50995 3.78923 6.15439C3.83327 5.63282 3.9734 4.97955 4.46745 4.48134C4.96532 3.97929 5.62128 3.83566 6.14615 3.79027C6.50497 3.75924 6.91509 3.77078 7.23212 3.7797C7.35579 3.78318 7.4653 3.78626 7.55208 3.78626C8.24449 3.78626 8.69316 3.5837 9.20782 3.06904L9.24319 3.03367C9.74606 2.53075 10.1759 2.10089 10.5656 1.80358Z" fill="#5CD193" />
                          <path d="M15.887 9.03827C16.1421 9.5281 15.9519 10.132 15.462 10.3871C14.49 10.8934 13.555 11.9696 12.8248 13.0345C12.4716 13.5496 12.188 14.0296 11.9929 14.3805C11.8826 14.5752 11.7528 14.8299 11.7016 14.9329C11.544 15.2611 11.2202 15.478 10.8567 15.4986C10.4931 15.5192 10.147 15.3405 9.95328 15.0321C9.74708 14.7037 9.40717 14.3884 9.07359 14.1372C8.97796 14.0631 8.66656 13.8627 8.52281 13.7718C8.03775 13.5081 7.85783 12.901 8.12137 12.4158C8.38498 11.9304 8.9921 11.7507 9.47742 12.0143L9.47903 12.0152L9.7263 12.1614C9.8677 12.2496 10.0613 12.3774 10.2766 12.5395C10.3774 12.6154 10.4866 12.7015 10.5998 12.7973C10.7656 12.5232 10.9585 12.2198 11.1754 11.9034C11.9452 10.7808 13.1102 9.35702 14.5382 8.61329C15.028 8.35817 15.6319 8.54844 15.887 9.03827Z" fill="#5CD193" />
                        </svg>
                        {stage.count} successful referral
                        {stage.count > 1 ? "s" : ""}: {stage.reward}
                      </div>
                    </div>)} v7={{
      width: `${currentReferrals / nextStage.count * 100}%`
    }} v8={currentReferrals} v9={nextStage.count} v10={() => setIsEmployerOpen(!isEmployerOpen)} v11={<AnimatePresence mode="wait">
                  {(userData.employerEmails || userData.employerSMS) && <motion.span initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -10
      }} transition={{
        duration: 0.2
      }} style={badgeStyle}>
                      {"Reach out directly to support for rewards"}
                    </motion.span>}
                </AnimatePresence>} v12={<AnimatePresence>
                {false && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="space-y-2">
                    <div className="text-xs text-light-100 mt-2">
                      Get contacted directly by employers or recruiters.
                    </div>
                    <div className="flex space-x-4">
                      <Checkbox checked={userData.employerEmails !== undefined ? userData.employerEmails : true} onToggle={() => handleToggle("employerEmails", !userData.employerEmails)} label="Email" />
                      <Checkbox checked={userData.employerSMS || false} onToggle={() => handleToggle("employerSMS", !userData.employerSMS)} label="SMS" />
                    </div>
                  </motion.div>}
              </AnimatePresence>} />,
    3: /*@million jsx-skip*/<JSX_content_4 v0={userData.points || 0} />
  };
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const [hoveredPage, setHoveredPage] = useState(null);
  const tabRefs = useRef([]);
  useEffect(() => {
    const updateIndicator = () => {
      const activeIndex = hoveredPage !== null ? hoveredPage : currPage;
      if (tabRefs.current[activeIndex]) {
        const {
          offsetLeft,
          offsetWidth
        } = tabRefs.current[activeIndex];
        setIndicatorStyle({
          left: offsetLeft,
          width: offsetWidth
        });
      }
    };
    updateIndicator();
  }, [currPage, hoveredPage, tabRefs.current]);
  return /*@million jsx-skip*/<Settings_2 v0={userData.name?.charAt(0)} v1={userData.name} v2={userData.email} v3={titles.slice(0, -1).map((title, index) => <div key={index} ref={el => tabRefs.current[index] = el} className={`relative ${currPage === index ? "bg-neutral-50 text-primary-600 rounded-md shadow-[0px_1px_2px_rgba(16,_24,_40,_0.04)] box-border shrink-0 overflow-hidden border-[1px] border-solid border-neutral-700" : "border-[1px] hover:bg-gray-neutral-100/60 text-gray-50 border-solid border-white"} text-sm font-semibold transition-colors duration-300 rounded-md py-3 px-4 cursor-pointer`} onClick={() => setCurrPage(index)} onMouseEnter={() => setHoveredPage(index)} onMouseLeave={() => setHoveredPage(null)}>
                    {title}
                    {title === "Referral program" && <AnimatePresence mode="wait">
                        <motion.span initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -10
      }} transition={{
        duration: 0.2
      }} style={badgeStyle}>
                          {"Earn rewards"}
                        </motion.span>
                      </AnimatePresence>}
                  </div>)} v4={<div ref={el => tabRefs.current[3] = el} className={`relative ${currPage === titles.length - 1 ? "bg-neutral-50 text-primary-600 rounded-md shadow-[0px_1px_2px_rgba(16,_24,_40,_0.04)] box-border shrink-0 overflow-hidden border-[1px] border-solid border-neutral-700" : "border-[1px] hover:bg-red-100 hover:text-red-500 text-gray-50 border-solid border-white"} text-sm font-semibold transition-colors duration-300 rounded-md py-3 px-4 cursor-pointer`} onClick={() => handleSignOut()}>
                  {titles[3]}
                </div>} v5={indicatorStyle} v6={content[currPage]} v7={<AddNewAccountModal show={showAddNewModal} onClose={() => setShowAddNewModal(false)} />} />;
};
export default Settings;